/**
 * @ngdoc component
 * @name home.component:itxWorldwideRegions
 * @description
 * Show the Continents and react on user actions in select, hover and clean.
 */
(function () {
    'use strict';

    var itxWorldwideRegions = {
        bindings: {
            continents: '<',
            hoverRegion: '&',
            selectRegion: '&',
            cleanRegion: '&'
        },
        controller: itxWorldwideRegionsCtrl,
        templateUrl: 'worldwide-regions.component.html'
    };

    itxWorldwideRegionsCtrl.$inject = [];

    function itxWorldwideRegionsCtrl() {
        var _this = this;

        _this.$onInit = function () {};

        _this.onCleanRegion = function (event) {
            _this.cleanRegion({ event: event });
        };

        _this.onHoverRegion = function (event) {
            _this.hoverRegion({ event: event });
        };

        _this.onSelectRegion = function (event) {
            _this.selectRegion({ event: event });
        };
    }

    angular.module('itxApp.home').component('itxWorldwideRegions', itxWorldwideRegions);
})();
